(function () {
  if (window.__cardSwatchesInit) return;
  window.__cardSwatchesInit = true;

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('.card-swatches__dot');
    if (!dot || !dot.dataset.img) return;

    event.preventDefault();
    event.stopPropagation();

    var card = dot.closest('.card-wrapper');
    if (!card) return;

    var images = card.querySelectorAll('.card__media img');
    if (images.length) {
      var primary = images[0];
      primary.removeAttribute('loading');
      primary.srcset = dot.dataset.srcset || '';
      primary.src = dot.dataset.img;

      // Remove the hover image rather than hiding it. Sense fades the first
      // image out on hover via img:first-child:not(:only-child), so a merely
      // hidden sibling still counts as a child and the card goes blank.
      for (var i = 1; i < images.length; i++) images[i].remove();
    }

    if (dot.dataset.url) {
      var links = card.querySelectorAll('a.full-unstyled-link');
      for (var j = 0; j < links.length; j++) links[j].href = dot.dataset.url;
    }

    var siblings = dot.closest('.card-swatches').querySelectorAll('.card-swatches__dot');
    for (var k = 0; k < siblings.length; k++) siblings[k].setAttribute('aria-pressed', 'false');
    dot.setAttribute('aria-pressed', 'true');
  });
})();
